import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { pageRoutes } from "../routes/pageRoutes";
import { pipGetTeamDirectory } from "../utils/pip";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import banner_images from "/images/inner_bg_3452121.png";

const HeroSection = ({
  label = "",
  subtitle = "",
  banner_text = "",
  breadcrumbItems = [],
  banner_image = "/images/inner_bg_3452121.png",
}) => {
  const navigate = useNavigate();
  const { user } = pipGetTeamDirectory();

  const { pathname } = useLocation();
  return (
    <>
      <div
        class="hero"
        style={{
          backgroundImage: `url(${banner_image})`,
        }}
      >
        {pathname == pageRoutes?.more?.teamDirectory && !user && (
          <button
            type="button"
            onClick={() =>
              navigate(pageRoutes.more?.teamDirectoryRegisterLogin)
            }
            class="btn btn-secondary ct_btn_animate  rc_hero_btn_top_right d-flex align-items-center gap-2"
          >
            <i class="fa-solid fa-right-to-bracket"></i> Sign In / Sign Up as
            Team
          </button>
        )}
        {pathname == pageRoutes?.more?.teamDirectory && user && (
          <button
            type="button"
            onClick={() => {
              localStorage.removeItem("Team-Member-Detail");
              navigate(pageRoutes?.more?.teamDirectory);
            }}
            class="btn btn-secondary ct_btn_animate  rc_hero_btn_top_right rc_hero_btn_red_danger"
          >
            <i class="fa-solid fa-power-off"></i> Log Out as Team
          </button>
        )}
        <div class="container ">
          <div class="row justify-content-between">
            <div class="col-lg-8 mx-auto text-center">
              <div class="intro-excerpt">
                {label}
                {subtitle && (
                  <p class="mb-0 ct_ff_orbitron ct_fs_24">{subtitle}</p>
                )}

                {/* <ul className="ps-0 mb-0 ct_breadcrumb mt-3">
                  {breadcrumbItems?.length != 0 &&
                    breadcrumbItems?.map((item, index) => (
                      <li key={index}>
                        {index < breadcrumbItems.length - 1 ? (
                          <a
                            className="text-white"
                            href="javascript:void(0)"
                            onClick={() => navigate(item?.path)}
                          >
                            {item.name}
                          </a>
                        ) : (
                          <> {item?.name}</>
                        )}
                        {index < breadcrumbItems.length - 1 && (
                          <>
                            {" "}
                            <span> / </span>
                          </>
                        )}
                      </li>
                    ))}
                </ul> */}

                {pathname == pageRoutes?.more?.teamDirectory && !user && (
                  <div className="mt-4">
                    <p>Sign up for a free page in our Team and Bot Directory</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
